/*
 * @Author: limengxue888 106235002+limengxue888@users.noreply.github.com
 * @Date: 2022-11-03 13:38:24
 * @LastEditors: limengxue888 106235002+limengxue888@users.noreply.github.com
 * @LastEditTime: 2024-09-04 16:33:45
 * @FilePath: \crm-new-fontend\weixin\client\src\store\index.js
 * @Description: 
 */
import Vue from 'vue'
import Vuex from 'vuex'
import baseModule from '@/store/base'
import managerRiskQuestionModule from "@/store/managerRiskQuestion";
import vuexPlugin from './vuexPlugin'; // 引入刚才创建的插件import createLogger from './plugins/logger';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex)

export default new Vuex.Store({
  namespaced: true,
  modules: {
    base: baseModule,
    mrqModule:managerRiskQuestionModule
  },
  plugins: [vuexPlugin, createPersistedState({
    storage: window.sessionStorage, // 或者使用 localStorage
  })]
})
